const env = {
    development : {
        APP_NAME     : 'Orbiter - Reembolso',
        BASE_API_URL : 'http://192.168.0.100:3000/', //'http://localhost:3000',
        USER_KEY     : '__reembolso_usuario',
        SYSTEM_LOGO  : '/static/logo_orbiter_app.png',
        LOGIN_LOGO   : '/static/logo_orbiter_login.png',
        ALT_LOGO     : 'Orbiter Engenharia & Consultoria',
    },
    staging : {
        APP_NAME     : 'IdeaCrafter - Reembolso',
        BASE_API_URL : 'https://reembolso-orbiter-api.herokuapp.com/',
        USER_KEY     : '__reembolso_usuario',
        SYSTEM_LOGO  : '/static/logo_reembolso_app.png',
        LOGIN_LOGO   : '/static/logo_reembolso_login.png',
        ALT_LOGO     : 'IdeaCrafter - Reembolso',
    },
    production : {
        APP_NAME     : 'Orbiter - Reembolso',
        BASE_API_URL : 'https://reembolso.orbiter.com.br/api/',
        USER_KEY     : '__reembolso_usuario',
        SYSTEM_LOGO  : '/static/logo_orbiter_app.png',
        LOGIN_LOGO   : '/static/logo_orbiter_login.png',
        ALT_LOGO     : 'Orbiter Engenharia & Consultoria',
    }
};

if (!process.env.NODE_ENV) {
    process.env.NODE_ENV = 'development';
}

export const appName    = process.env.APP_NAME     || env[process.env.NODE_ENV].APP_NAME;
export const baseApiUrl = process.env.BASE_API_URL || env[process.env.NODE_ENV].BASE_API_URL;
export const userKey    = process.env.USER_KEY     || env[process.env.NODE_ENV].USER_KEY;
export const logo       = process.env.SYSTEM_LOGO  || env[process.env.NODE_ENV].SYSTEM_LOGO;
export const loginLogo  = process.env.LOGIN_LOGO   || env[process.env.NODE_ENV].LOGIN_LOGO;
export const altLogo    = process.env.ALT_LOGO     || env[process.env.NODE_ENV].ALT_LOGO;

export default {
    appName,
    baseApiUrl,
    userKey,
    logo,
    loginLogo,
    altLogo
}
